'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 13, viewBox: "0 0 12 13", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#12_svg__clip0_39877_64187)" },
        React__namespace.createElement("path", { d: "M4.78515 2.75275C5.06779 2.48898 5.51074 2.50428 5.77451 2.78693C6.03827 3.06957 6.02297 3.51252 5.74033 3.77629L3.29129 6.06177C3.19995 6.14701 3.11717 6.22439 3.04207 6.29525L10.5697 6.29525C10.9563 6.29525 11.2697 6.60865 11.2697 6.99525C11.2697 7.38185 10.9563 7.69525 10.5697 7.69525L3.00622 7.69525C3.0906 7.77516 3.18517 7.86359 3.29128 7.96261L5.70853 10.2185C5.99117 10.4822 6.00646 10.9252 5.74269 11.2078C5.47893 11.4905 5.03597 11.5058 4.75333 11.242L2.3036 8.95582C1.96449 8.63941 1.65908 8.35446 1.44483 8.09109C1.21099 7.80364 1.01256 7.45619 1.01257 7.01218C1.01257 6.56816 1.21099 6.22072 1.44484 5.93327C1.6591 5.6699 1.9645 5.38495 2.30361 5.06855L4.78515 2.75275Z", fill: props.fillColor, fillOpacity: 0.92 })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "12_svg__clip0_39877_64187" },
            React__namespace.createElement("rect", { width: 11.9952, height: 11.9952, fill: "white", transform: "translate(0 0.997375)" })))));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
